jQuery(document).ready(function ($){    
    $.noConflict();
     document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

if ($("#SortBy-mobile").length > 0) {
    let label = $(".mobile-facets__sort label");
    let widthString = ((label.text().length * 8.5) / 10.0) + "rem";
    $("#SortBy-mobile").css("text-indent", widthString);
  }

});